var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "BjDrawerForm",
        {
          ref: "BjDrawerForm",
          staticClass: "actual-drawer-form",
          attrs: {
            form: _vm.form,
            width: "800px",
            "label-width": "120px",
            "confirm-button-text": _vm.isView ? "" : _vm.$t("okText"),
          },
          on: { handleConfirm: _vm.handleConfirm },
        },
        _vm._l(_vm.actualStaffSections, function (section) {
          return _c(
            "div",
            { key: section.listName, staticClass: "actual-staff-section" },
            [
              _c(
                "BjDivider",
                [
                  _vm._v(" " + _vm._s(section.title) + " "),
                  _c("span", { staticClass: "actual-staff-section-subtitle" }, [
                    _vm._v(_vm._s(section.subtitle)),
                  ]),
                  _c(
                    "template",
                    { slot: "right" },
                    [
                      _vm.isView && section.listName === "staffList"
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "danger" },
                              on: {
                                click: function ($event) {
                                  return _vm.discardActualData()
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("discardText")))]
                          )
                        : _vm._e(),
                      !_vm.isView
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.onAddStaff(section)
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("addText")))]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                2
              ),
              _c(
                "el-form",
                {
                  ref: section.formRef,
                  refInFor: true,
                  attrs: { model: _vm.form, rules: section.rules },
                },
                [
                  _c(
                    "el-table",
                    {
                      ref: section.tableRef,
                      refInFor: true,
                      staticClass: "actual-allocation-table",
                      attrs: {
                        data: _vm.form[section.listName],
                        stripe: "",
                        border: "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          type: "expand",
                          width: "1",
                          "class-name": "work-detail-expand",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "work-detail-panel" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "work-detail-grid work-detail-grid--header",
                                        },
                                        [
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "AccountManagement.work.count"
                                                )
                                              )
                                            ),
                                          ]),
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "AccountManagement.work.targetGroup"
                                                )
                                              )
                                            ),
                                          ]),
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "AccountManagement.work.percentage"
                                                )
                                              )
                                            ),
                                          ]),
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "AccountManagement.work.action"
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _vm._l(
                                        row.workDetails,
                                        function (detail, detailIndex) {
                                          return _c(
                                            "div",
                                            {
                                              key: detailIndex,
                                              staticClass: "work-detail-grid",
                                            },
                                            [
                                              _c("div", [
                                                _vm._v(_vm._s(detailIndex + 1)),
                                              ]),
                                              _c(
                                                "div",
                                                [
                                                  _c("BjSelectLov", {
                                                    attrs: {
                                                      "option-list":
                                                        _vm.departmentOptionList,
                                                      clearable: false,
                                                      disabled: _vm.isView,
                                                    },
                                                    model: {
                                                      value: detail.deptName,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          detail,
                                                          "deptName",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "detail.deptName",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "work-detail-percentage",
                                                },
                                                [
                                                  _c(
                                                    "BjInputNumber",
                                                    {
                                                      staticClass:
                                                        "work-detail-percentage-input",
                                                      attrs: {
                                                        min: 0,
                                                        max: 100,
                                                        precision: 0,
                                                        disabled: _vm.isView,
                                                      },
                                                      model: {
                                                        value:
                                                          detail.percentage,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            detail,
                                                            "percentage",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "detail.percentage",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "template",
                                                        { slot: "append" },
                                                        [_vm._v("%")]
                                                      ),
                                                    ],
                                                    2
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "div",
                                                [
                                                  _c("el-button", {
                                                    staticClass:
                                                      "work-detail-delete",
                                                    attrs: {
                                                      disabled: _vm.isView,
                                                      type: "text",
                                                      icon: "el-icon-delete",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.onDeleteWorkDetail(
                                                          row,
                                                          detailIndex,
                                                          section.tableRef,
                                                          section.listName
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "work-detail-add-row" },
                                        [
                                          _c("div"),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "work-detail-add-cell",
                                            },
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  staticClass:
                                                    "work-detail-add",
                                                  attrs: {
                                                    disabled: _vm.isView,
                                                    type: "text",
                                                    icon: "el-icon-plus",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.onAddWorkDetail(
                                                        row
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "AccountManagement.work.addGroup"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c("div"),
                                        ]
                                      ),
                                    ],
                                    2
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          type: "index",
                          label: _vm.$t("AccountManagement.work.count"),
                          align: "center",
                          width: "80",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: { align: "center" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "header",
                              fn: function () {
                                return [
                                  _c("span", { staticClass: "red" }, [
                                    _vm._v("*"),
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("AccountManagement.staff.name")
                                      )
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                var $index = ref.$index
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticStyle: {
                                        "margin-top": "10px !important",
                                      },
                                      attrs: {
                                        prop:
                                          section.listName +
                                          "." +
                                          $index +
                                          ".name",
                                      },
                                    },
                                    [_c("span", [_vm._v(_vm._s(row.name))])]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { align: "center", width: "300" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "header",
                              fn: function () {
                                return [
                                  _c("span", { staticClass: "red" }, [
                                    _vm._v("*"),
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("AccountManagement.work.hour")
                                      )
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                var $index = ref.$index
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticStyle: {
                                        "margin-top": "10px !important",
                                      },
                                      attrs: {
                                        prop:
                                          section.listName +
                                          "." +
                                          $index +
                                          "." +
                                          section.hourField,
                                        rules: section.rules[section.hourField],
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "work-hour-range-picker",
                                        },
                                        [
                                          _c("el-time-picker", {
                                            staticClass: "work-hour-picker",
                                            attrs: {
                                              value:
                                                row[section.hourField] &&
                                                row[section.hourField][0],
                                              format: "HH:mm",
                                              "value-format":
                                                "yyyy-MM-dd HH:mm:ss",
                                              placeholder:
                                                _vm.$t("form.startTimeText"),
                                              "picker-options":
                                                _vm.getStartTimePickerOptions(
                                                  row[section.hourField]
                                                ),
                                              "prefix-icon": "",
                                              disabled: _vm.isView,
                                              editable: false,
                                            },
                                            on: {
                                              input: function ($event) {
                                                return _vm.setWorkHour(
                                                  row,
                                                  section.hourField,
                                                  0,
                                                  $event
                                                )
                                              },
                                            },
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "work-hour-separator",
                                            },
                                            [_vm._v("-")]
                                          ),
                                          _c("el-time-picker", {
                                            staticClass: "work-hour-picker",
                                            attrs: {
                                              value:
                                                row[section.hourField] &&
                                                row[section.hourField][1],
                                              format: "HH:mm",
                                              "value-format":
                                                "yyyy-MM-dd HH:mm:ss",
                                              placeholder:
                                                _vm.$t("form.endTimeText"),
                                              "picker-options":
                                                _vm.getEndTimePickerOptions(
                                                  row[section.hourField]
                                                ),
                                              "prefix-icon": "",
                                              disabled: _vm.isView,
                                              editable: false,
                                            },
                                            on: {
                                              input: function ($event) {
                                                return _vm.setWorkHour(
                                                  row,
                                                  section.hourField,
                                                  1,
                                                  $event
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("BusinessThirdOrderAdd.form.Operation"),
                          align: "center",
                          fixed: "right",
                          width: "150",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onToggleAllocate(
                                            scope.row,
                                            section.tableRef,
                                            section.listName
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.isRowExpanded(
                                            scope.row,
                                            section.listName
                                          )
                                            ? _vm.$t(
                                                "AccountManagement.work.close"
                                              )
                                            : _vm.$t(
                                                "AccountManagement.work.allocate"
                                              )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        disabled: _vm.isView,
                                        type: "text",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onDelete(
                                            scope.$index,
                                            section
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("delText")))]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        }),
        0
      ),
      _c("BjLogTableDialog", {
        ref: "logTable",
        attrs: {
          "query-api": _vm.queryApi,
          "query-params": _vm.queryParams,
          "staff-role-list": _vm.staffRoleList,
          "staff-dept-list": _vm.staffDeptList,
        },
        on: { onConfirm: _vm.onConfirm },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: 6 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("AccountManagement.staff.name"),
                          prop: "staffName",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            placeholder: _vm.$t("AccountManagement.staff.name"),
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.staffName,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "staffName", $$v)
                            },
                            expression: "queryParams.staffName",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 6 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("AccountManagement.staff.department"),
                          prop: "staffDepartment",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "option-list": _vm.staffDeptList,
                            placeholder: _vm.$t(
                              "AccountManagement.staff.department"
                            ),
                          },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.queryParams.staffDepartment,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "staffDepartment", $$v)
                            },
                            expression: "queryParams.staffDepartment",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }